@let step = steps();
@let currentSliderValue = sliderValue();
@let min = isMinValue();
@let max = isMaxValue();
@let disabled = isDisabled();
<div class="market-slider">
    <div class="market-slider__wrapper">
        <div class="market-slider__content">
            <div class="market-slider__button-wrapper">
                <button
                    class="market-slider__button--decrement"
                    ds-button-icon
                    variant="outline"
                    kind="tertiary"
                    size="small"
                    [disabled]="disabled || min"
                    (click)="!min && incrementOrDecrementPoints()">
                    <vn-icon name="theme-minus" height="12" width="12" />
                </button>
            </div>

            <div class="market-slider__slider">
                <ms-slider
                    class="market-slider__slider-component"
                    [steps]="step"
                    [value]="currentSliderValue"
                    [disabled]="disabled"
                    (valueChange)="onValueChange($event)" />

                <div
                    class="market-slider__slider-overlay"
                    [msSliderGradient]="step"
                    [sliderValue]="currentSliderValue"
                    [centerValue]="centerValue()"></div>
            </div>

            <div class="market-slider__button-wrapper">
                <button
                    class="market-slider__button--increment"
                    ds-button-icon
                    variant="outline"
                    kind="tertiary"
                    size="small"
                    [disabled]="disabled || max"
                    (click)="!max && incrementOrDecrementPoints(true)">
                    <vn-icon name="theme-plus" height="12" width="12" />
                </button>
            </div>
        </div>

        <div class="market-slider__values" [class.market-slider__values--disabled]="disabled">
            <span class="market-slider__min">{{ leftLabel() ?? step[0] }}</span>
            <span class="market-slider__max">{{ rightLabel() ?? step[step.length - 1] }}</span>
        </div>
    </div>
</div>
